import Axios from "../../../lib/Axios";

/**
 * Token Status API Helper
 * 
 * API functions for token status page
 */

/**
 * Get users by token status
 * @param {Object} filters - Filter parameters
 * @param {number} filters.token_count - Filter users with tokens >= this value
 * @param {number} filters.limit - Pagination limit
 * @param {number} filters.page - Pagination page number
 * @returns {Promise} API response with user_ids array and pagination
 */
export const getTokenStatusList = async (filters = {}) => {
  const {
    token_count,
    limit = 50,
    page = 1,
  } = filters;

  // Build query parameters object
  const params = {
    limit: limit.toString(),
    page: page.toString(),
  };
  
  if (token_count !== undefined && token_count !== null && token_count !== "") {
    params.token_count = token_count.toString();
  }

  console.log("API Params:", params);

  // GET /admin/users/token-status
  const result = await Axios.get("admin/users/token-status", { params });
  const user_ids = result?.data?.result?.user_ids || [];
  const pagination = result?.data?.result?.pagination || {};
  const filter_applied = result?.data?.result?.filter_applied || "";
  const total_count = result?.data?.result?.total_count || 0;
  const count = result?.data?.result?.count || 0;
  
  return {
    data: user_ids,
    pagination: {
      currentPage: pagination.currentPage || page,
      limit: pagination.limit || limit,
      totalPages: pagination.totalPages || 1,
      totalRecords: pagination.totalRecords || 0,
    },
    filter_applied,
    total_count,
    count,
  };
};

/**
 * Add tokens to all users with zero tokens
 * @param {Object} data - Add tokens data
 * @param {number} data.tokens - Number of tokens to add
 * @returns {Promise} API response
 */
export const addTokensToZeroUsers = async (data) => {
  const { tokens } = data;
  
  if (!tokens || tokens <= 0) {
    throw new Error("tokens must be a positive number");
  }

  // POST /admin/broadcast/add-tokens
  const result = await Axios.post("admin/broadcast/add-tokens", {
    tokens,
  });
  
  return result;
};

